import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import type { User } from '../../../../@types/global';
import { latestImagesVisitDateAtom } from '../../atoms';
import type { ImageObject } from '../../types';

import { PatientDownloadable } from './PatientDownloadable';

export const PatientDownloadableLoader = ({
  currentImage,
  selectedPhoto,
}: {
  currentImage: ImageObject;
  selectedPhoto?: ImageObject;
  secondImage?: ImageObject;
}) => {
  const user: User = useSelector((state: any) => state?.login?.user);
  const patients = useSelector((state: any) => state.annotator?.patients) || {};
  const { id: selectedPatientId } = useParams<{ id: string }>();

  const currentPatient = patients[selectedPatientId] || {};
  const visitDate = useAtomValue(latestImagesVisitDateAtom);

  return (
    <PatientDownloadable
      currentImage={currentImage}
      selectedPhoto={selectedPhoto}
      practiceName={user.primaryPracticeName || ''}
      patientName={currentPatient.name}
      visitDate={visitDate}
    />
  );
};
